import { render, staticRenderFns } from "./AlipayPay.vue?vue&type=template&id=015ad369&scoped=true"
import script from "./AlipayPay.vue?vue&type=script&lang=js"
export * from "./AlipayPay.vue?vue&type=script&lang=js"
import style0 from "./AlipayPay.vue?vue&type=style&index=0&id=015ad369&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015ad369",
  null
  
)

export default component.exports